// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1zSvE","right":"styles_right__2x48T"};